import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  tableCell: {
    padding: '0 18px 0 18px',
    sortDirection: 'asc',
  },
  nameCell: {
    padding: '0 18px 0 18px',
    width: '14rem',
  },
  typeCell: {
    padding: '0 18px 0 18px',
    width: '9rem',
  },
  actionCell: {
    padding: '5px 18px 19px 18px',
    width: '7rem',
  },
  nameSpace: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    padding: '15px 0 10px',
  },
  accDetails: {
    paddingLeft: 6,
    height: 19,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: theme.palette.greyScale[2],
  },
  greyAccDetails: {
    extend: 'accDetails',
    color: `${theme.palette.greyScale[4]} !important`,
  },
  paddedSubheader: {
    paddingLeft: 12,
  },
  fields: {
    '& div': {
      '&:hover': {
        background: theme.palette.greyScale[6],
        borderRadius: '4px',
      },
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  errorOutline: {
    '& div': {
      '& fieldset': {
        borderColor: theme.palette.error.main,
        borderWidth: 1,
      },
    },
  },
  errorPadding: {
    paddingBottom: 20,
  },
  ignoreFields: {
    paddingRight: 40,
    '& div': {
      color: `${theme.palette.greyScale[4]} !important`,
      '& fieldset': {
        borderWidth: 0,
      },
    },
  },
  tableRow: {
    '&:hover': {
      boxShadow: '2px 2px 6px 0 rgba(0, 0, 0, 0.3)',
    },
  },
  typeBox: {
    borderRadius: '4px',
    '&:hover':{
      background: theme.palette.greyScale[6],
    },
    '& div': {
      '& div': {
        paddingLeft: 8,
      },
      '&:focus': {
        borderRadius: '4px',
        '&:hover':{
          background: theme.palette.greyScale[6],
        },
      },
    },
  },
  ignoreTypeBox: {
    '&:hover':{
      background: theme.palette.greyScale[7],
    },
    '& div': {
      color: theme.palette.greyScale[4],
      '& div': {
        paddingLeft: 8,
      },
    },
  },
  nameInput: {
    padding: '6px 6px',
    width: '260px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block',
  },
  ignoreSet: {
    border: 0,
  },
  body1: theme.typography.body2,
  errorType: {
    paddingLeft: 6,
    height: 19,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: `${theme.palette.error.main} !important`,
  },
}));

